var version = {
    "name":      "dativery",
    "buildDateCode": "20250408-104857",
    "buildDate": "Tue Apr 08 2025 10:48:57 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20250408-104857",
    "backupUIVersion": "2.2.0-20250407-203053"
}
;
 export default version;